import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  attribution?: string;
};

export function PullQuote({ children, attribution }: Props) {
  return (
    <figure className="border-l-2 border-accent pl-6 md:pl-10 py-2 max-w-4xl">
      <blockquote>
        <p className="display-md font-display italic font-medium text-ink-primary leading-tight">
          {children}
        </p>
      </blockquote>
      {attribution && (
        <figcaption className="mono-meta text-ink-muted mt-4">— {attribution}</figcaption>
      )}
    </figure>
  );
}
